import { render, staticRenderFns } from "./ten-enterprises-comparison.vue?vue&type=template&id=785cad8c&"
import script from "./ten-enterprises-comparison.vue?vue&type=script&lang=js&"
export * from "./ten-enterprises-comparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports